// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3ec5v","emails":"CreateEditClinics_emails__MAceU","emailTagLabel":"CreateEditClinics_emailTagLabel__WSbDx"};